import { render, staticRenderFns } from "./VDesignRequestReturnToWorkModal.vue?vue&type=template&id=5d2569bb&"
import script from "./VDesignRequestReturnToWorkModal.vue?vue&type=script&lang=ts&"
export * from "./VDesignRequestReturnToWorkModal.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignRequestReturnToWorkModal.vue?vue&type=style&index=0&id=5d2569bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports